<div class="body">
  <div class="container">
    <div class="row title-box mt-3">
      <div class="col-12 col-sm-12">
        <h3>Modificar usuario <span class="sub-2">Aliado Financiero</span></h3>
      </div>
    </div>
    <div class="justify-content-md-center">
      <form [formGroup]="filterForm" class="custom-form">
        <div class="row">
          <div class="col-12 col-sm-4 mt-4">
            <div class="mb-3 form-label">
              <label for="tipoDoc" class="form-label">Tipo de documento</label>
              <select name="miselectTI" type="number" class="form-control" formControlName="tipoDocumento">
                <option [value]="null">{{"Seleccione"}}</option>
                @for (item of listaDocumentos; track item) {
                  <option [value]="item.idTipoDocIdentidad">{{item.nombre}}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-4 mt-4">
            <div class="mb-3 form-label">
              <label for="numDoc" class="form-label">Número de documento</label>
              <input type="text" minlength="5" maxlength="10" class="form-control" formControlName="numeroDocumento">
            </div>
          </div>
          <div class="col-12 col-sm-4 mt-4">
            <div class="mb-3 form-label">
              <label for="nombres" class="form-label">Nombres y Apellidos del Usuario</label>
              <input type="text" maxlength="40" class="form-control" formControlName="nombresYApellidos">
            </div>
          </div>
        </div>
        <div class="row justify-content-md-center g-3">
          <div class="col-12 col-md-2 container-btn">
            <button type="submit" class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="filtrar()">Buscar</button>
          </div>
          <div class="col-12 col-md-2 container-btn">
            <button type="submit" class="btn btn-primary hvr-shrink" style="width: 180px;" routerLink="/intermediario/home">Volver</button>
          </div>
        </div>
      </form>
    </div>

    @if (listaUsuarios.length>0) {
      <div class="row mt-4">
        <div class="table-responsive">
          <table class="table table-striped table-borderless rounded">
            <thead class="table_head">
              <tr>
                <th scope="col">Nombres y apellidos</th>
                <th>Tipo de identificación</th>
                <th>Número de identificación</th>
                <th>Correo electrónico</th>
                <th>Estado</th>
                <th>Modificar información</th>
              </tr>
            </thead>
            <tbody>
              @for (usuario of listaUsuarios; track usuario; let i = $index) {
                <tr>
                  <th scope="row">{{usuario.primerNombre}} {{usuario.primerApellido}}</th>
                  <td>{{usuario.tipoIdentificacionCodigo}}</td>
                  <td>{{usuario.numeroIdentificacion}}</td>
                  <td>{{usuario.correoElectronico}}</td>
                  <td>{{usuario.estado}}</td>
                  <td><button id="btn-editar" type="button" class="hvr-shrink" data-bs-toggle="modal" data-bs-target="#editModal" (click)="editarFila(i)">
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
<div class="footer-body"></div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
